import { useTranslation } from 'react-i18next';
import ButtonTab from './components/Button';
import { Icon } from './components/icon';
import Subject from './components/Subject';
import StepWizard from 'react-step-wizard';
import { useState } from 'react';
import SenderName from './components/Sender';
import { useEmailSetting } from './hook/useEmailSetting';

export default function EmailSetting() {
    const { t } = useTranslation();
    const [state, setState] = useState();
    const [activeStep, setActiveStep] = useState(0);
    const { getEmailSettings, emailList, loading } = useEmailSetting();

    const setInstance = (SW) => {
        setState({
            ...state,
            SW,
        });
        setActiveStep(SW.state.activeStep);
    };

    return (
        <div>
            <div className="title ">{t('common.EmailSetting')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} /
                </span>
                <span> {t('common.EmailSetting')} </span>
            </div>
            <div className="flex items-center gap-4 my-4">
                <ButtonTab
                    key="subject"
                    title="Subject Email"
                    icon={Icon.email}
                    active={activeStep === 0}
                    onClick={() => state?.SW?.goToStep(1)}
                />
                <ButtonTab
                    key="sender"
                    title="Sender Name"
                    icon={Icon.sender}
                    active={activeStep === 1}
                    onClick={() => state?.SW?.goToStep(2)}
                />
            </div>
            <StepWizard
                hashKey="tab"
                isHashEnabled
                instance={setInstance}
                onStepChange={({ activeStep }) => {
                    setActiveStep(activeStep - 1);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
            >
                <Subject
                    getEmailSettings={getEmailSettings}
                    emailList={emailList}
                    loading={loading}
                />
                <SenderName getEmailSettings={getEmailSettings} />
            </StepWizard>
        </div>
    );
}
